<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-4 mb-4 pb-4 mb-lg-0 pb-lg-0 order-lg-0 order-1">
        <SubscriptionPlan
          :plan="plans[1]"
          primary="#5FBBD7"
        />
      </div>

      <div class="col-lg-4 mb-5 pb-5 mb-lg-0 pb-lg-0 order-lg-1 order-0">
        <SubscriptionPlan
          :plan="plans[0]"
          primary="#F03E33"
          secondary="#FF7133"
          ref="specialPlan"
        >
          <span slot="disclaimer">Maior economia!</span>
          <LandingButton slot="button">EU CONSIGO CHEGAR LÁ!</LandingButton>
        </SubscriptionPlan>
      </div>

      <div class="col-lg-4 order-2">
        <SubscriptionPlan
          :plan="plans[2]"
          primary="#7DB891"
        >
          <span slot="pricingDisclaimer">Menos de <strong class="plan__pricing__disclaimer__amount">R$ 1,30</strong> por dia!</span>
        </SubscriptionPlan>
      </div>
    </div>
  </div>
</template>

<script>
  import SubscriptionPlan from '@/components/landing/SubscriptionPlan'
  import LandingButton from '@/components/buttons/LandingButton'

  export default {
    components: {
      SubscriptionPlan,
      LandingButton,
    },

    props: {
      plans: { type: Array, required: true }
    }
  }
</script>

